import {Injectable, OnDestroy} from '@angular/core';

import {ReplaySubject} from 'rxjs';
import {auditTime, map, pairwise, takeUntil} from 'rxjs/operators';

import {ConnectionStore} from '@stores/connection.store';
import {DataConfigStore} from '@stores/data-config.store';

import {PosthogWrapperService} from '@services/posthog-wrapper.service';

import {UtilsPL2 as U} from '@common/utils/dist/utils/utils-pl2.js';

import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PosthogDataConfigReactor implements OnDestroy {
  private _destroyed$ = new ReplaySubject<void>();

  private readonly _auditTime = 10000;

  constructor(
    private connectionStore: ConnectionStore,
    private dataConfigStore: DataConfigStore,
    private posthogWrapperService: PosthogWrapperService,
  ) {
    if (U.isEmpty(environment.posthogApiKey)) {
      return;
    }

    this.dataConfigStore.state$
      .pipe(
        auditTime(this._auditTime),
        map((dcs) => Object.keys(dcs ?? [])),
        pairwise(),
        map(([prevGCIds, newGCIds]) => {
          const distinctGCIds = newGCIds.filter(
            (gCId) => prevGCIds.indexOf(gCId) < 0,
          );
          if (distinctGCIds.length > 0) {
            this.posthogWrapperService.capture('graphs_used', {
              graphs: distinctGCIds,
              device: this.connectionStore.state()?.deviceConfig?.id,
              first: prevGCIds.length === 0 ? '1' : '0',
            });
          }
        }),
        takeUntil(this._destroyed$),
      )
      .subscribe();
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
